/**
 * Pricing helpers shared between the org form and the org mutations.
 *
 * These are extracted into a pure utility so the business rules can be unit
 * tested against the real source instead of inline reimplementations.
 */

/**
 * Resolve the frontend pricing model for an org loaded from the backend.
 *
 * Hybrid is a frontend-only concept. The backend PriceModel enum only knows
 * CPM and Percentage, so we rely on the org config's `isHybrid` flag to know
 * whether a CPM-backed org should actually render as Hybrid. When the flag is
 * absent we fall back to the raw backend model and never infer Hybrid from
 * default AuctionPlus percentage values (which would false-flag every CPM org).
 */
export const resolveModelType = (config, pricingModel) => {
  if (config?.isHybrid === true) return 'Hybrid';
  return pricingModel?.model || 'CPM';
};

/**
 * Map the frontend model type to a value the backend PriceModel enum accepts.
 */
export const mapModelTypeForBackend = (modelType) => {
  return modelType === 'Hybrid' ? 'CPM' : modelType;
};

/**
 * For CORE/ENTERPRISE orgs the advertiser and contract values are the same
 * single price. For other levels the contract side keeps its own value.
 */
export const preparePricingField = (level, advertiserValue, contractValue) => {
  const isDirectContract = level === 'CORE' || level === 'ENTERPRISE';
  return isDirectContract ? advertiserValue : contractValue;
};

/**
 * CORE/ENTERPRISE always have hasContract=true; otherwise preserve the toggle.
 */
export const prepareContractFlag = (level, contract) => {
  return level === 'CORE' || level === 'ENTERPRISE' ? true : contract;
};
